module.exports = __webpack_public_path__ + "img/product-shot_06.9aa856fe.jpg";